import { render, staticRenderFns } from "./Component-VideoMonitor.vue?vue&type=template&id=6a2aabe8&scoped=true&"
import script from "./Component-VideoMonitor.vue?vue&type=script&lang=js&"
export * from "./Component-VideoMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2aabe8",
  null
  
)

export default component.exports